import { onMounted, onUnmounted } from "vue";

export function useEscapeEvent(methodToTrigger): void {
	const handleEscKey = (e: KeyboardEvent): void => {
		if (e.key === "Escape") {
			methodToTrigger();
		}
	};

	onMounted(() => window.addEventListener("keydown", handleEscKey));
	onUnmounted(() => window.removeEventListener("keydown", handleEscKey));
}
